import React from 'react';
import Select from 'react-select';

/**
 * A wrapper around react-select that forces the menu to always open downward.
 * Props:
 * - options: Array<{ value: string, label: string }>
 * - value: string | null
 * - onChange: (value: string) => void
 * - placeholder?: string
 * - isDisabled?: boolean
 * - styles?: object (optional react-select styles override)
 */
const AlwaysDownSelect = ({
  options,
  value,
  onChange,
  placeholder = '선택하세요',
  isDisabled = false,
  styles: customStyles = {}
}) => {
  const selectedOption = options?.find(opt => opt.value === value) || null;

  const styles = {
    container: (base) => ({
      ...base,
      width: '100%'
    }),
    control: (base, state) => ({
      ...base,
      backgroundColor: state.isDisabled ? '#f1f3f5' : 'white',
      minHeight: 44,
      borderRadius: 8,
      borderColor: state.isFocused ? '#80bdff' : '#ced4da',
      boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
      '&:hover': { 
        borderColor: state.isDisabled ? '#ced4da' : (state.isFocused ? '#80bdff' : '#ced4da') 
      }
    }),
    menu: (base) => ({
      ...base,
      marginTop: 4
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999
    }),
    ...customStyles
  };

  return (
    <Select
      options={options}
      value={selectedOption}
      onChange={(opt) => onChange(opt ? opt.value : '')}
      placeholder={placeholder}
      isDisabled={isDisabled}
      menuPlacement="bottom"
      menuPosition="fixed"
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      styles={styles}
      noOptionsMessage={() => '선택할 항목이 없습니다'}
    />
  );
};

export default AlwaysDownSelect;


